/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { MapTo, Container } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';
import {
  StaticWrapper,
  Hero,
  BannerText,
  BrandRibbon,
  EditableHTLWrapper,
  CobrandCardHorizontalFlexible,
  CardHorizontalFeature,
  CardVertical,
  CarouselGallery,
  Text,
  DataBlock,
  CardHorizontalMini,
  MiniCardCarouselContainer,
  VariableColumnContainer,
  AccordionContainerEnhanced,
  CardCarouselContainer,
  LinkBanner,
  IconBlock,
  RichText,
  TabContainer,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  Media,
  BannerLayered,
  Footer,
} from '@marriott/mi-common-static-components';
import { OHighlight, OBannerText } from '@marriott/mi-designsystem-components';
import {
  BrgClaimForm,
  ContactUsForm,
  ContentTabs,
  LegalConsentValidator,
  LoyaltyTier,
  ModalPageContent,
  PrivacyRightsWrapper,
  LegalSeparator,
  LegalMultiLink,
} from '@marriott/mi-legal-components';

export const AEM_REACT_MAPPING = {
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/content/hero`]: Hero,
  [`mi-aem-common-spa/components/content/brandribbon`]: BrandRibbon,
  [`mi-aem-common-spa/components/content/variablecolumncontainer`]: VariableColumnContainer,
  [`mi-aem-common-spa/components/content/accordioncontainerenhanced`]: AccordionContainerEnhanced,
  [`mi-aem-common-spa/components/content/text`]: Text,
  [`mi-aem-common-spa/components/content/richtext`]: RichText,
  [`mi-aem-common-spa/components/content/bannertext`]: BannerText,
  [`mi-aem-common-spa/components/content/datablock`]: DataBlock,
  [`mi-aem-utils/components/content/o-highlight`]: OHighlight,
  [`mi-aem-utils/components/content/o-banner-text`]: OBannerText,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  [`mi-aem-common-spa/components/content/card-mini-carousel-container`]: MiniCardCarouselContainer,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-common-spa/components/content/carouselgallery`]: CarouselGallery,
  [`mi-aem-common-spa/components/content/linkbanner`]: LinkBanner,
  [`mi-aem-common-spa/components/content/iconblock`]: IconBlock,
  [`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`]: CobrandCardHorizontalFlexible,
  [`mi-aem-common-spa/components/content/tabcontainer`]: TabContainer,
  [`mi-aem-legal-spa/components/content/contactusform`]: ContactUsForm,
  [`mi-aem-legal-spa/components/content/multilinks`]: LegalMultiLink,
  [`mi-aem-legal-spa/components/content/contenttabs`]: ContentTabs,
  [`mi-aem-legal-spa/components/content/membertier`]: LoyaltyTier,
  [`mi-aem-legal-spa/components/content/legalconsents`]: LegalConsentValidator,
  [`mi-aem-legal-spa/components/content/legalmodal`]: ModalPageContent,
  [`mi-aem-legal-spa/components/content/privacyrightswrapper`]: PrivacyRightsWrapper,
  [`mi-aem-legal-spa/components/separator`]: LegalSeparator,
  [`mi-aem-common-spa/components/content/bannerlayered`]: BannerLayered,
  [`mi-aem-legal-spa/components/content/brgclaimform`]: BrgClaimForm,
  [`mi-aem-common-spa/components/content/media`]: Media,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  ['mi-aem-homepage-spa/components/content/universal-footer']: Footer,
};
export const defineComponentMapping = (allowedComponents, pagePath, isAuthorMode, featureFlagLogo) => {
  MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper);
  MapTo(`mi-aem-common-spa/components/content/hero`)(Hero);
  MapTo(`mi-aem-common-spa/components/content/brandribbon`)(props => (
    <BrandRibbon {...props} featureFlagLogo={featureFlagLogo} />
  ));

  MapTo(`mi-aem-common-spa/components/content/variablecolumncontainer`)(props => (
    <VariableColumnContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/accordioncontainerenhanced`)(props => (
    <AccordionContainerEnhanced {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/text`)(Text);
  MapTo(`mi-aem-common-spa/components/content/richtext`)(RichText);
  MapTo(`mi-aem-common-spa/components/content/bannertext`)(BannerText);
  MapTo(`mi-aem-common-spa/components/content/datablock`)(DataBlock);
  MapTo(`mi-aem-utils/components/content/o-highlight`)(props => <OHighlight {...props} isAuthorMode={isAuthorMode} />);
  MapTo(`mi-aem-utils/components/content/o-banner-text`)(props => (
    <OBannerText {...props} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(CardHorizontalMini);
  MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical);
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(CardHorizontalFeature);
  MapTo(`mi-aem-common-spa/components/content/card-mini-carousel-container`)(MiniCardCarouselContainer);
  MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(props => (
    <CardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/carouselgallery`)(CarouselGallery);
  MapTo(`mi-aem-common-spa/components/content/linkbanner`)(LinkBanner);
  MapTo(`mi-aem-common-spa/components/content/iconblock`)(IconBlock);
  MapTo(`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`)(CobrandCardHorizontalFlexible);
  MapTo(`mi-aem-common-spa/components/content/tabcontainer`)(props => (
    <TabContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-legal-spa/components/content/contactusform`)(ContactUsForm);
  MapTo(`mi-aem-legal-spa/components/content/multilinks`)(LegalMultiLink);
  MapTo(`mi-aem-legal-spa/components/content/contenttabs`)(ContentTabs);
  MapTo(`mi-aem-legal-spa/components/content/legalconsents`)(LegalConsentValidator);
  MapTo(`mi-aem-legal-spa/components/content/legalmodal`)(ModalPageContent);
  MapTo(`mi-aem-legal-spa/components/content/membertier`)(props => (
    <LoyaltyTier {...props} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`mi-aem-legal-spa/components/content/privacyrightswrapper`)(PrivacyRightsWrapper);
  MapTo(`mi-aem-legal-spa/components/separator`)(LegalSeparator);
  MapTo('mi-aem-legal-spa/components/content/brgclaimform')(BrgClaimForm);
  MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(props => (
    <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(BannerLayered);
  MapTo(`mi-aem-common-spa/components/content/media`)(Media);
  MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper);
  MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper);
  MapTo(`mi-aem-homepage-spa/components/content/universal-footer`)(Footer);

  const existingMappings = Object.keys(AEM_REACT_MAPPING);
  if (allowedComponents) {
    allowedComponents.forEach(mapping => {
      const baseModelPath = '/jcr:content/root/responsivegrid/';
      const componentPath = mapping.path.split(baseModelPath)[1];

      if (existingMappings.indexOf(componentPath) === -1) {
        MapTo(componentPath)(EditableHTLWrapper, {
          emptyLabel: mapping.title,
          isEmpty: false,
        });
      } else {
        console.log('mapping exists', componentPath);
      }
    });
  }
};
